import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-opd-modal',
  templateUrl: './opd-modal.component.html',
  styleUrls: ['./opd-modal.component.scss'],
})
export class OpdModalComponent implements OnInit {
  isLoading = true;
  Errors = null;
  titles = null;
  mode = null;
  opds = null;
  data = null;
  Success = null;
  depts = null;
  socs = null;
  subs = null;
  items = null;

  stateForm = new FormGroup({
    id: new FormControl(0, Validators.required),
    soc_id: new FormControl('', Validators.required),
    dept_id: new FormControl(0, Validators.required),
    sub_dept_id: new FormControl(0, Validators.required),
    package_id: new FormControl('', Validators.required),
    effective_date: new FormControl(new Date(), Validators.required),
    item_of_service_id: new FormControl(0, Validators.required),
    soc_name: new FormControl('', Validators.required),
    dept_name: new FormControl('', Validators.required),
    sub_dept_name: new FormControl('', Validators.required),
    package_name: new FormControl('', Validators.required),
    pack_price: new FormControl('', Validators.required),
    tot_serv_price: new FormControl('', Validators.required),
    net_amt: new FormControl('', Validators.required),
  });

  constructor(
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public auth: SettingsService
  ) {}

  onSubmit(e) {
    e.preventDefault();
    // if (this.stateForm.valid) {
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      id,
      soc_id,
      dept_id,
      sub_dept_id,
      package_id,
      effective_date,
      soc_name,
      dept_name,
      sub_dept_name,
      package_name,
      pack_price,
      tot_serv_price,
      net_amt,
      item_of_service_id,
    } = this.stateForm.value;
    this.auth
      .postOpd(
        id,
        soc_id,
        dept_id,
        sub_dept_id,
        package_id,
        effective_date,
        soc_name,
        dept_name,
        sub_dept_name,
        package_name,
        pack_price,
        tot_serv_price,
        net_amt,
        item_of_service_id
      )
      .subscribe(
        (resSuccess) => {
          this.data = resSuccess;
          this.isLoading = false;
          console.log(resSuccess);

          if (this.data.success) {
            this.closeModal();
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            this.Errors = 'Not successful, please try again';
            console.log(resSuccess);
          }
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr);
        }
      );
    // } else {
    //   // If the form is not valid, possibly show an error message or handle it accordingly
    //   this.Errors = 'Please fill all required fields before submitting.';
    // }
  }

  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {
    this.auth.getSocs().subscribe(
      (resSuccess) => {
        this.socs = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
    this.auth.getItems().subscribe(
      (resSuccess) => {
        this.items = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getSubDept().subscribe(
      (resSuccess) => {
        this.subs = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getDept().subscribe(
      (resSuccess) => {
        this.depts = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getOpd().subscribe(
      (resSuccess) => {
        this.opds = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }

  addNew() {
    this.mode = 'add';
  }
  edit(opd) {
    this.mode = 'edit';
    this.stateForm.patchValue({
      id: opd.id,
      package_id: opd.package_id,
      effective_date: new Date(),
      soc_name: opd.soc_name,
      dept_name: opd.dept_name,
      sub_dept_name: opd.sub_dept_name,
      package_name: opd.package_name,
      pack_price: opd.pack_price,
      tot_serv_price: opd.tot_serv_price,
      net_amt: opd.net_amt,
      item_of_service_id: opd.item_of_service_id,
    });
    console.log(this.stateForm.value);
  }

  delete(title) {
    this.auth.delSet('/api/opdpackage/deleteOPD', title.id).subscribe(
      (resSuccess) => {
        this.opds = this.opds.filter((dattum) => dattum.id !== title.id);
        this._snackBar.open('Deleted Successfully', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      },
      (resErr) => {
        this._snackBar.open('Error try again', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      }
    );
  }

  socChange(event: any) {
    let soc = this.socs.filter((t) => t.SOC_ID == event.value);
    this.stateForm.patchValue({
      soc_name: soc[0].SOC_NAME,
    });
    console.log(this.stateForm.value);
  }

  deptChange(event: any) {
    let dept = this.depts.filter((t) => t.id == event.value);
    this.stateForm.patchValue({
      dept_name: dept[0].name,
    });
    console.log(this.stateForm.value);
  }

  subChange(event: any) {
    let subDept = this.subs.filter((t) => t.id == event.value);
    this.stateForm.patchValue({
      sub_dept_name: subDept[0].name,
    });
    console.log(this.stateForm.value);
  }
}
